import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Typography } from '@mui/material';

const DataTile = ({ title = '', children, sx, className }) => {
    if (!children || (children.length && !children?.find?.(child => !!child))) return null;
    return (
        <Paper
            sx={{
                border: '1px solid',
                borderColor: 'grey.200',
                borderRadius: '6px',
                marginBottom: '32px',
            }}
            elevation={0}
        >
            {title && (
                <Box
                    sx={theme => ({
                        padding: '30px 60px',
                        borderBottom: `1px solid ${theme.palette.grey[200]}`,
                        [theme.breakpoints.down('sm')]: {
                            padding: '10px 20px',
                        },
                    })}
                >
                    <Typography sx={{ fontSize: '22px', color: 'common.black' }} variant="h6">
                        {title}
                    </Typography>
                </Box>
            )}
            <Box
                sx={theme => ({
                    padding: '60px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    [theme.breakpoints.down('sm')]: { flexDirection: 'column', padding: '20px' },
                    ...(typeof sx === 'function' ? sx(theme) : sx),
                })}
                className={className}
            >
                {children}
            </Box>
        </Paper>
    );
};

DataTile.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    sx: Box.propTypes.sx,
};

export default DataTile;
